export default "__VITE_ASSET__BBI9ecs$__"